import { ErrorApi } from 'api/interfaces';
import { toast } from 'react-toastify';
import translation from '../../locales/translation';

type Replacers = Record<string, string>;

/**
 * @param replacers: enviar um objeto com as chaves sendo os valores que devem ser substituídos
 * e os valores sendo a string que substituirá o valor
 *
 * Exemplo:
 * { "#1#": "22:45"}
 */
export default function ErrorHandler(error: ErrorApi, replacers?: Replacers) {
  let errMessage: string;
  if (Array.isArray(error.details) && error.details.length > 0) {
    errMessage = error.details[0].message;
  } else {
    errMessage = error.message;
  }

  let message =
    translation.Toasts.Errors.Keys[
      errMessage as keyof typeof translation.Toasts.Errors.Keys
    ] ?? errMessage;

  Object.entries(replacers ?? {}).forEach(([chave, valor]) => {
    message = message.replace(chave, valor);
  });

  toast.error(message);
}

// export default function ErrorHandler(error: ErrorApi, showToast: Function) {
//   if (Array.isArray(error.details) && error.details.length > 0) {
//     showToast({
//       pauseOnFocusLoss: true,
//       theme: ToastTypes.Error,
//       showStatusBar: true,
//       timeout: 4000,
//       label: error.details[0].message,
//     });
//   } else {
//     showToast({
//       pauseOnFocusLoss: true,
//       theme: ToastTypes.Error,
//       showStatusBar: true,
//       timeout: 4000,
//       label: error.message,
//     });
//   }
// }
